import { render, staticRenderFns } from "./FlipkartSleepwell.vue?vue&type=template&id=5f5bb645&lang=pug"
import script from "./FlipkartSleepwell.js?vue&type=script&lang=js&external"
export * from "./FlipkartSleepwell.js?vue&type=script&lang=js&external"
import style0 from "./FlipkartSleepwell.vue?vue&type=style&index=0&id=5f5bb645&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports